import { INSUFFICIENT_BALANACE_HIDE, INSUFFICIENT_BALANACE_SHOW } from '../constants/alertDialog';

export const showInsufficientDialog = () => {
    return {
        type: INSUFFICIENT_BALANACE_SHOW,
    };
};

export const hideInsufficientDialog = () => {
    return {
        type: INSUFFICIENT_BALANACE_HIDE,
    };
};
